import { useEffect, useState } from "react";

const inputStyle = {
    width: '100%', padding: '11px 12px', borderRadius: 10,
    border: '1.5px solid #cbd5e1', marginTop: 4,
    boxSizing: 'border-box', fontSize: 14, background: 'white',
    outline: 'none', color: '#0f172a',
};

const labelStyle = { fontSize: 12, fontWeight: 700, color: '#475569' };

export const CambiarPasswordModal = ({ show, onClose, onSave, usuario }) => {

    const [password, setPassword] = useState('');
    const [confirmar, setConfirmar] = useState('');
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (!show) {
            setPassword('');
            setConfirmar('');
            setErrors({});
        }
    }, [show]);

    const handleSubmit = (e) => {
        e.preventDefault();

        const newErrors = {};

        if (!password.trim()) {
            newErrors.password = 'Debe ingresar la nueva contraseña';
        } else if (password.trim().length < 4) {
            newErrors.password = 'La contraseña debe tener al menos 4 caracteres';
        }

        if (password !== confirmar) {
            newErrors.confirmar = 'Las contraseñas no coinciden';
        }

        setErrors(newErrors);

        if (Object.keys(newErrors).length > 0) return;

        onSave({ password: password.toUpperCase() });
    };

    if (!show) return null;

    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(15, 23, 42, 0.65)', backdropFilter: 'blur(6px)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            zIndex: 9999, padding: 20, fontFamily: "'Inter', Arial, sans-serif",
        }}>
            <div style={{
                background: '#ffffff', borderRadius: 24, width: '100%',
                maxWidth: 480, maxHeight: '92vh', overflowY: 'auto',
                boxShadow: '0 25px 60px rgba(0,0,0,0.25)', border: '1px solid #e2e8f0',
            }}>
                {/* Header */}
                <div style={{
                    background: 'linear-gradient(135deg, var(--color-primario) 0%, var(--color-primario-oscuro) 100%)',
                    padding: '20px 26px', color: 'var(--color-primario-contraste)',
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                    position: 'sticky', top: 0, zIndex: 1,
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                        <div style={{
                            width: 44, height: 44, borderRadius: 14,
                            background: 'rgba(255,255,255,0.18)',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            fontSize: 20,
                        }}>
                            <i className="fa-solid fa-key"></i>
                        </div>
                        <div>
                            <h4 style={{ margin: 0, fontWeight: 800, fontSize: 18 }}>
                                Cambiar contraseña
                            </h4>
                            <p style={{ margin: '3px 0 0', opacity: 0.85, fontSize: 12.5 }}>
                                {(usuario?.nombreCompleto || usuario?.usuario || '').toUpperCase()}
                            </p>
                        </div>
                    </div>
                    <button type="button" onClick={onClose} style={{
                        background: 'rgba(255,255,255,0.15)', border: 'none', color: 'var(--color-primario-contraste)',
                        width: 34, height: 34, borderRadius: '50%', fontSize: 16, cursor: 'pointer',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                    }}><i className="fa-solid fa-xmark"></i></button>
                </div>

                <form onSubmit={handleSubmit} style={{ padding: 26 }}>

                    <div className="row g-3" style={{ marginBottom: 8 }}>

                        <div className="col-12">
                            <label style={labelStyle}>Nueva contraseña</label>
                            <input
                                type="password"
                                value={password}
                                onChange={(e) => {
                                    setPassword(e.target.value);
                                    setErrors(prev => ({ ...prev, password: '' }));
                                }}
                                placeholder="Contraseña"
                                maxLength={20}
                                autoFocus
                                style={{
                                    ...inputStyle,
                                    borderColor: errors.password ? '#ef4444' : '#cbd5e1',
                                }}
                            />
                            {errors.password && (
                                <div style={{ fontSize: 12, color: '#dc2626', marginTop: 4, fontWeight: 600 }}>
                                    {errors.password}
                                </div>
                            )}
                        </div>

                        <div className="col-12">
                            <label style={labelStyle}>Confirmar contraseña</label>
                            <input
                                type="password"
                                value={confirmar}
                                onChange={(e) => {
                                    setConfirmar(e.target.value);
                                    setErrors(prev => ({ ...prev, confirmar: '' }));
                                }}
                                placeholder="Repita la contraseña"
                                maxLength={20}
                                style={{
                                    ...inputStyle,
                                    borderColor: errors.confirmar ? '#ef4444' : '#cbd5e1',
                                }}
                            />
                            {errors.confirmar && (
                                <div style={{ fontSize: 12, color: '#dc2626', marginTop: 4, fontWeight: 600 }}>
                                    {errors.confirmar}
                                </div>
                            )}
                        </div>

                    </div>

                    {/* Botones */}
                    <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end', marginTop: 26 }}>
                        <button type="button" onClick={onClose} style={{
                            padding: '12px 22px', borderRadius: 12, border: '1.5px solid #cbd5e1',
                            background: 'white', color: '#475569', fontWeight: 700, cursor: 'pointer', fontSize: 14,
                        }}>
                            Cancelar
                        </button>
                        <button type="submit" style={{
                            padding: '12px 28px', borderRadius: 12, border: 'none',
                            background: 'linear-gradient(135deg, var(--color-primario) 0%, var(--color-secundario) 100%)',
                            color: 'var(--color-marca-contraste)', fontWeight: 800, cursor: 'pointer', fontSize: 14,
                            boxShadow: '0 4px 14px rgba(var(--color-primario-rgb),0.3)',
                            display: 'inline-flex', alignItems: 'center', gap: 8,
                        }}>
                            <i className="fa-solid fa-check"></i>
                            Actualizar
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};
